import * as React from 'react'

import { cn } from '~/shared/common/utils'

type InputProps = React.ComponentProps<'input'> & {
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  iconClassName?: string
  error?: string
  errorClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, icon, iconClassName, iconPosition = 'left', error, errorClassName, ...props }, ref) => {
  const hasIcon = Boolean(icon)
  const hasError = Boolean(error)
  return (
    <div className="relative">
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-[#DCD8D7] bg-[#FEFDFB] px-3 py-1 text-base transition-colors appearance-none file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-[#8A3DFF] focus:ring-4 focus:ring-[#8A3DFF]/16 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          hasIcon && iconPosition === 'left' && 'pl-10',
          hasIcon && iconPosition === 'right' && 'pr-10',
          hasError && 'border-destructive focus:border-destructive focus:ring-destructive/16',
          className
        )}
        ref={ref}
        aria-invalid={hasError ? 'true' : 'false'}
        {...props}
      />
      {hasIcon ? <div className={cn('absolute inset-y-0 flex items-center', iconPosition === 'left' ? 'left-0 pl-3' : 'right-0 pr-3', iconClassName)}>{icon}</div> : null}
      {hasError ? <span className={cn('text-sm text-destructive mt-1 block', errorClassName)}>{error}</span> : null}
    </div>
  )
})
Input.displayName = 'Input'

export { Input }
